import React from "react";
import { useWatch } from "react-hook-form";
import KioskV5 from "./V5/KioskV5";
import Kiosk from "./Kiosk";

function Zuil() {
  const appTarget = useWatch({ name: "appTarget" });

  return appTarget === "appv5.js" ? <KioskV5 /> : <Kiosk />;
}

export default Zuil;
